import { render, staticRenderFns } from "./ChinaMapTerimal.vue?vue&type=template&id=8f054770&scoped=true&"
import script from "./ChinaMapTerimal.vue?vue&type=script&lang=js&"
export * from "./ChinaMapTerimal.vue?vue&type=script&lang=js&"
import style0 from "./ChinaMapTerimal.vue?vue&type=style&index=0&id=8f054770&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f054770",
  null
  
)

export default component.exports